import React from 'react';

import { useIntl } from 'react-intl';

import { Row, Col, Form, Input, FormInstance } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';

import useDefaultMaxLengthFieldError from '../../../../../hooks/useDefaultMaxLengthFieldError';
import { ReportNcmFormValues } from '@/core/domain/reports/operational/Report.types';

interface Props {
  form?: FormInstance<ReportNcmFormValues>;
}

function NcmReportForm({ form }: Props) {
  const intl = useIntl();
  const defaultMaxLengthFieldError = useDefaultMaxLengthFieldError();

  return (
    <Form form={form}>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12} md={11}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'ncm.modal.report.form.description',
            })}
            name="description"
          >
            <Input />
          </FloatingFormItem>
        </Col>
        <Col xs={24} sm={12} md={11}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'ncm.modal.report.form.codeNcm',
            })}
            name="code"
            rules={[defaultMaxLengthFieldError(8)]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default NcmReportForm;
